import * as types from "../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.TICKET_UPDATING:
            return { ...state, loading: true };

        case types.TICKET_RESET:
        case types.TICKET_UPDATING_COMPLETED:
            return { loading: false };

        case types.TICKET_UPDATING_CANCELLED:
            if (!state.loading) {
                return { loading: false, err: action.err };
            }
            return state;

        case types.TICKET_UPDATING_FAILED:
            return { loading: false, err: action.err };

        default:
            return state;
    }
};
